/**
 * A global namespace for `Meta` key.
 * e.which = 93 equivalent
 */
const keyMeta = "Meta";

export default keyMeta;
